<template>
  <Dialogs :dialog="dialog" :handleClose="close" :close="{clickModal:false,pressEscape:false,showClose:false,}">
    <template #content>
        <div class="dialog_content">
          <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
           
            <el-form-item label="新密码" prop="password">
              <el-input maxlength="100" :type="passwordType" v-model="form.password" style="width:405px;" placeholder="请输入">
                <i class="el-icon-view el-input__icon" slot="suffix" @click="showPassword"></i>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
    </template>
    <!-- 按钮 -->
    <template #btns>
      <el-button type="primary" @click="submitForm">确定</el-button>
    </template>
  </Dialogs>
</template>
<script>
import {carbonSinkResetPassword,} from "@/api/api"
import { Encrypt } from "@/utils/secret.js";
import Dialogs from "@/components/dialogs/dialogs.vue"

export default {
  props:['dialog','handleClose'],
  data(){
      return{
          data:{
            size: 720,
            visible: true,
            title: "新增",
          },
          loading:false,
          close:function(){},
          showBtn:false,
          // 提交表单
          form:{
            id:'',
            password:"", // 密码
          },
          // 文件列表
          fileList:[],
          // 校验
          rules:{
            password:[{ required: true, message: "请填写密码" },{min:8,message:'密码长度不小于8位'},{max:18,message:'密码长度不大于18位'},{pattern:/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9]{8,18}$/,message:'包括至少1个大写字母，1个小写字母，1个数字'}],
          },
          // 密码类型
          passwordType:"password"
      }
  },
  methods:{
    // 提交
    async submitForm(){
      let bol = true;
      this.$refs["form"].validate((valid) => {
          if (!valid) {
          bol = false;
          return false;
          }
      });
      if(bol){
        let form = { ...this.form }
        form.key = this.getUUID(16, 62)
        form.password = Encrypt(form.password,form.key,form.key)
        const res = await carbonSinkResetPassword(form)
        if(res.data.code == 200){
          window.localStorage.setItem('passWordFormat',true)
          this.$message.success(res.data.message);
          // this.data.visible = false
          this.$alert('您本次的密码为 '+res.data.data, '', {
            confirmButtonText: '确定',
            callback: action => {
              this.data.visible = false
            }
          });
        }else{
            this.$message.error(res.data.message);
        }
      }
    },
    // 显示密码
    showPassword() {
      this.passwordType == "" ?
        (this.passwordType = "password") :
        (this.passwordType = "");
    },
    // 获取随机字符串
    getUUID(len, radix) {
      var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
      var uuid = []
      var i
      radix = radix || chars.length
      if (len) {
        for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
      } else {
        var r
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
        uuid[14] = '4'
        for (i = 0; i < 36; i++) {
          if (!uuid[i]) {
            r = 0 | Math.random() * 16
            uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r]
          }
        }
      }
      return uuid.join('')
    },
  },
  mounted(){
    let userInfo = window.localStorage.getItem('userInfo')
    if(userInfo){
        userInfo = JSON.parse(userInfo)
        this.form.id = userInfo.id
    }
  },
  components:{
    Dialogs,
  },
   watch:{
    dialog:{
      handler(val){
        this.$set(this,'passwordType',"password")
        this.$set(this,'data',val)
      },
      deep:true,
      immediate:true
    },
    handleClose:{
      handler(val){
        this.$set(this,'close',val)
      },
      immediate:true
    },
  }
}
</script>
<style scoped>
    ::v-deep .inlinitem.el-form-item {
        display: inline-flex;
        justify-content: flex-start;
    }
    ::v-deep .inlinitem.el-form-item .el-form-item__content {
        margin-left: 2px !important;
    }
    .h120 {
        height: 120px;
    }
    ::v-deep .h120 .el-textarea__inner {
        height: 120px;
    }
</style>